import { QueryKey } from "@tanstack/react-query";

export function mergeQueryKeysWithParams<TQueryKey extends QueryKey>(
  queryKey: TQueryKey,
  params?: Record<string, unknown>
) {
  return [...queryKey, params] as unknown as TQueryKey;
}
